import React, { useState } from 'react'
import './discussions.css'
import { Container, Grid, Tooltip, useMediaQuery } from '@material-ui/core'
import { ButtonHLPure, ChatBoxGLPure, DialogSystemGLPure, GridSelectionHLPure, HeaderHLPure, PromotionalFooterPure, SimpleLoading } from '../../pures'
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { useTranslation } from "react-i18next";
import { newProfileIcon } from '../../../assets/logos/icons';

function DiscussionsView(props) {
    const {
        chats,
        selectedChat,
        skip,
        showChat,
        goBack,

        membersChat,
        usersChat,
        conversation,
        createMessage,
    } = props;

    const { t } = useTranslation();
    const [filePdf, setFilePDF] = useState({})
    const mobileResolution = useMediaQuery("(max-width:560px)");

    // GRID
    const HeaderCellOne = (props) => {
        return <span className='discussionsView-chatGrid-col1 discussionsView-chatGrid-header'>{props.title}</span>;
    }

    const CellColumnOne = (props) => {
        const { dataItem } = props;

        return (
            <td className={dataItem.selected ? "selected" : null}>
                <div className='discussionsView-chatGrid-col1'>
                    <p className='discussionsView-title'><Link to={dataItem.solicitudeUrl}>{dataItem.solicitudeName}</Link></p>
                    <p className='discussionsView-subtitle'>{dataItem.workflowName}</p>
                    {mobileResolution && <p className='discussionsView-subtitle'>Últ. mensaje {dataItem.lastMessage}</p>}
                </div>
            </td>
        );
    }

    const HeaderCellTwo = (props) => {
        return <span className='discussionsView-chatGrid-header'>{props.title}</span>;
    }

    const CellColumnTwo = (props) => {
        const { dataItem } = props;

        return (
            <td className={`discussionsView-chatGrid-col2 ${dataItem.selected ? "selected" : null}`}>
                <p>{dataItem.lastMessage}</p>
            </td>
        );
    }

    // CHAT
    const handleInputChangeChat = (e) => {
        let file = e.target.files[0];
        setFilePDF(file);
        let reader = new FileReader();
    };

    if (props.isLoading) {
        return <SimpleLoading />
    }

    return (
        <>
            {
                props.isLoading
                    ? <SimpleLoading />
                    : <div className={"discussionsView"}>
                        <Container>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <HeaderHLPure title={"Discusiones disponibles"} />
                                </Grid>

                                <Grid item xs={12}>
                                    <Container maxWidth={"lg"} disableGutters>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <GridSelectionHLPure
                                                    skip={skip}
                                                    take={6}
                                                    dataGrid={chats.map(item => item.workflowExecutionId == selectedChat?.workflowExecutionId ? { ...item, selected: true } : { ...item })}

                                                    styleGeneral
                                                    styleGeneralClass={"discussionsView-chatsGrid"}

                                                    columnOne
                                                    titleRow1={"Proceso"}
                                                    headerColumnOne={HeaderCellOne}
                                                    cellColumnOne={CellColumnOne}

                                                    columnTwo={!mobileResolution}
                                                    titleRow2={"Último mensaje"}
                                                    headerColumnTwo={HeaderCellTwo}
                                                    cellColumnTwo={CellColumnTwo}
                                                    headerColumnTwoClass={"discussionsView-chatGrid-col2"}

                                                    columnFive
                                                    widthColumnFive={50}
                                                    onSelectedItem={showChat}
                                                    setNameComponentUser={() => { /* no ocupo */ }}
                                                    setShowDetails={() => { /* no ocupo */ }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                {
                                                    selectedChat && <>
                                                        <Grid className="followUpActionsContractsView-headerUsersChat">
                                                            <span className="followUpActionsContractsView-titleGrid">
                                                                {t("panelBarHLPure.title.chat")}
                                                            </span>
                                                            <div className="followUpActionsContractsView-containersAvatars">
                                                                {membersChat.map((item, index) => (
                                                                    <div>
                                                                        <Tooltip
                                                                            openDelay={600}
                                                                            position="bottom"
                                                                            anchorElement="target"
                                                                            tooltipClassName="tooltipGeneralStyle"
                                                                        >
                                                                            <div>
                                                                                <img
                                                                                    title={item.name}
                                                                                    key={index}
                                                                                    src={
                                                                                        item.avatarUrl && item.avatarUrl !== ""
                                                                                            ? item.avatarUrl
                                                                                            : newProfileIcon
                                                                                    }
                                                                                    className="followUpActionsContractsView-avatar"
                                                                                    alt={item.name}
                                                                                />
                                                                            </div>
                                                                        </Tooltip>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </Grid>

                                                        <ChatBoxGLPure
                                                            user={usersChat}
                                                            conversation={conversation}
                                                            widthChat={1200}
                                                            heightChat={300}
                                                            placeholderChat={"Escribe algo"}
                                                            handleInputChange={handleInputChangeChat}
                                                            createMessage={createMessage}
                                                        />
                                                    </>
                                                }

                                            </Grid>
                                            <Grid item xs={12}>
                                                <Grid container justify='flex-end'>
                                                    <ButtonHLPure
                                                        primary
                                                        nameBtn={"Regresar"}
                                                        onClickBtn={goBack}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Container>
                                </Grid>

                                <Grid item xs={12}>
                                    <PromotionalFooterPure />
                                </Grid>
                            </Grid>
                        </Container>
                    </div>
            }

            <DialogSystemGLPure
                showLoadingRequesting={props.showLoadingRequesting}
                toggleLoadingRequesting={props.toggleLoadingRequesting}

                showCompletedRequesting={props.showCompletedRequesting}
                toggleCompletedRequesting={props.toggleCompletedRequesting}

                showWarningRequesting={props.showWarningRequesting}
                toggleWarningRequesting={props.toggleWarningRequesting}

                showErrorRequesting={props.showErrorRequesting}
                toggleErrorRequesting={props.toggleErrorRequesting}
                messageError={props.messageError} />
        </>
    )
}

export default DiscussionsView